import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Modal, Layout } from "antd";
import { RecoilRoot } from "recoil";
import { Header, Content } from "antd/es/layout/layout";
import { useApplicationContext } from "./context/application-context";
import CompanyLogo from "./components/company-logo";
import AppRoute, { isMobileWidth } from "./app-routes";
function App() {
    const { tenantSettings } = useApplicationContext();
    const [isModalVisible, setIsModalVisible] = useState(false);
    console.log("tenantSettings in App:", tenantSettings.tenantConfig.brandLogo.whiteBgLogo);
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        window.close();
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };
    return (_jsx(RecoilRoot, { children: _jsxs(Layout, { children: [_jsxs(Header, Object.assign({ style: {
                        display: "flex",
                        width: "100vw",
                        padding: isMobileWidth ? "10px" : "20px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#f4f6fb",
                        borderBottom: `2px solid ${tenantSettings
                            ? tenantSettings.tenantConfig.colorPalette.primaryColor
                            : "gray"} `,
                    } }, { children: [tenantSettings.tenantConfig.brandLogo && (_jsx(CompanyLogo, { brandLogo: tenantSettings.tenantConfig.brandLogo.whiteBgLogo })), _jsx(Modal, Object.assign({ title: "Confirm Close", visible: isModalVisible, onOk: handleOk, onCancel: handleCancel, okText: "Close", cancelText: "Cancel" }, { children: _jsx("p", { children: "Are you sure you want to close the window?" }) }))] })), _jsx(Content, Object.assign({ style: { height: "calc(100vh - 72px)" } }, { children: _jsx(AppRoute, {}) }))] }) }));
}
export default App;
